import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export interface ExportStatementsResult {
  startDate: string | null; // YYYY-MM-DD
  endDate: string | null;   // YYYY-MM-DD
  format: 'csv' | 'pdf';
}

@Component({
  selector: 'df-export-statements',
  templateUrl: './export-statements.component.html',
  styleUrls: ['./export-statements.component.scss']
})
export class ExportStatementsComponent {
  @Input() memberName: string = '';

  exportForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal
  ) {
    this.exportForm = this.fb.group({
      startDate: [null],
      endDate: [null],
      format: ['pdf', Validators.required]
    });
  }

  cancel(): void {
    this.activeModal.dismiss();
  }

  export(): void {
    if (!this.exportForm.valid) return;

    const v = this.exportForm.value;
    const result: ExportStatementsResult = {
      startDate: v.startDate,
      endDate: v.endDate,
      format: v.format
    };

    this.activeModal.close(result);
  }
}
